
/* お見積りリスト（価格はお問い合わせの製品用） */
(() => {
  const KEY = 'youon_quote_list';
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return mem; } };
  let mem = [];
  const write = list => { mem = list; try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} render(); };
  const contactUrl = () => (document.querySelector('[data-contact-url]') || {}).dataset?.contactUrl || '/pages/contact';

  // ドロワー
  const dr = document.createElement('div');
  dr.className = 'cart quote-drawer'; dr.id = 'quote'; dr.setAttribute('aria-hidden', 'true');
  dr.innerHTML = '<div class="sh" data-quote-close></div><div class="pn" role="dialog" aria-label="お見積りリスト">'
    + '<div class="hd"><b>お見積りリスト</b><button class="ibtn" type="button" aria-label="閉じる" data-quote-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>'
    + '<div class="items" id="quote-items"></div><div class="ft" id="quote-ft"></div></div>';
  document.body.appendChild(dr);

  // ヘッダーのアイコン（リストに1件以上あるときだけ表示）
  const hact = document.querySelector('.hact');
  let hbtn = null;
  if (hact) {
    hbtn = document.createElement('button');
    hbtn.type = 'button'; hbtn.className = 'ibtn quote-btn'; hbtn.setAttribute('aria-label', 'お見積りリスト'); hbtn.setAttribute('data-quote-open', '');
    hbtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5M10 13h6M10 17h6"/></svg><span class="cnt" data-quote-count data-n="0">0</span>';
    const cartBtn = hact.querySelector('[data-cart-open]');
    hact.insertBefore(hbtn, cartBtn || hact.firstChild);
  }

  const open = () => { render(); dr.classList.add('open'); dr.setAttribute('aria-hidden', 'false'); };
  const close = () => { dr.classList.remove('open'); dr.setAttribute('aria-hidden', 'true'); };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-quote-open]')) { e.preventDefault(); open(); }
    if (e.target.closest('[data-quote-close]')) close();
    const b = e.target.closest('#quote [data-qi]');
    if (b) { const list = read(); const i = +b.dataset.qi; const q = +b.dataset.q;
      if (q <= 0) list.splice(i, 1); else list[i].qty = Math.min(999, q); write(list); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  function render() {
    const list = read(), n = list.reduce((s, i) => s + i.qty, 0);
    if (hbtn) { hbtn.hidden = n === 0; const c = hbtn.querySelector('[data-quote-count]'); c.textContent = n; c.dataset.n = n; }
    const items = document.getElementById('quote-items'), ft = document.getElementById('quote-ft');
    if (!list.length) {
      items.innerHTML = '<div class="empty">お見積りリストは空です<a class="btn ghost" href="/collections/all">製品を見る</a></div>';
      ft.hidden = true; return;
    }
    ft.hidden = false;
    items.innerHTML = list.map((it, k) => `<div class="citem">
      <a class="im" href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image)}" alt="">` : ''}</a>
      <div><b>${esc(it.title)}</b>${it.variant ? `<small>${esc(it.variant)}</small>` : ''}<small>価格はお問い合わせ</small>
        <div class="qty"><button type="button" data-qi="${k}" data-q="${it.qty - 1}" aria-label="減らす">−</button><span>${it.qty}</span><button type="button" data-qi="${k}" data-q="${it.qty + 1}" aria-label="増やす">＋</button></div></div>
      <button class="rm" type="button" data-qi="${k}" data-q="0">削除</button></div>`).join('');
    ft.innerHTML = `<div class="sum"><span>合計点数</span><b>${n}点</b></div>
      <a class="btn block" href="${esc(contactUrl())}?quote=1">この内容で見積りを依頼する</a>
      <small>お問い合わせフォームに製品リストが自動で入ります。担当者より、構成・台数・設置条件に応じたお見積りをご連絡いたします。</small>`;
  }

  window.YOUONQuote = {
    items: read,
    add(item) { const list = read(); const f = list.find(i => i.id === item.id); if (f) f.qty += item.qty; else list.push(item); write(list); },
    clear() { write([]); }, open, close
  };
  render();
})();
/* YOUON JAPAN theme */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const R = (window.YOUON && window.YOUON.routes) || { cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change' };
  const money = c => { const f = (window.YOUON && window.YOUON.moneyFormat) || '¥{{amount_no_decimals}}'; const n = Math.round(c / 100).toLocaleString('ja-JP'); return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n).replace(/<[^>]+>/g, ''); };
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const toast = m => { const t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('show'), 2600); };

  /* nav */
  const mnav = $('#mnav');
  $$('[data-nav-open]').forEach(b => b.addEventListener('click', () => mnav && mnav.classList.add('open')));
  $$('[data-nav-close]').forEach(b => b.addEventListener('click', () => mnav && mnav.classList.remove('open')));

  /* cart drawer */
  const cart = $('#cart');
  const openCart = () => { cart.classList.add('open'); cart.setAttribute('aria-hidden', 'false'); };
  const closeCart = () => { cart.classList.remove('open'); cart.setAttribute('aria-hidden', 'true'); };
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  document.addEventListener('click', e => { if (e.target.closest('[data-cart-close]')) closeCart(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); mnav && mnav.classList.remove('open'); } });

  const renderCart = c => {
    $$('[data-count]').forEach(e => { e.textContent = c.item_count; e.dataset.n = c.item_count; });
    const items = $('#cart-items'), ft = $('#cart-ft'); if (!items) return;
    if (!c.item_count) { items.innerHTML = `<div class="empty">カートは空です<a class="btn ghost" href="/collections/all">製品を見る</a></div>`; ft.hidden = true; return; }
    ft.hidden = false;
    items.innerHTML = c.items.map((it, k) => `<div class="citem">
      <div class="im">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')}" alt="">` : ''}</div>
      <div><b>${esc(it.product_title)}</b>${it.variant_title ? `<small>${esc(it.variant_title)}</small>` : ''}<small>${money(it.final_line_price)}</small>
        <div class="qty"><button type="button" data-line="${k + 1}" data-qty="${it.quantity - 1}" aria-label="減らす">−</button><span>${it.quantity}</span><button type="button" data-line="${k + 1}" data-qty="${it.quantity + 1}" aria-label="増やす">＋</button></div></div>
      <button class="rm" type="button" data-line="${k + 1}" data-qty="0">削除</button></div>`).join('');
    const tot = $('#cart-total'); if (tot) tot.textContent = money(c.total_price);
  };
  const refreshCart = () => fetch(R.cart + '.js').then(r => r.json()).then(renderCart);
  document.addEventListener('click', e => {
    const b = e.target.closest('#cart [data-line]'); if (!b) return;
    fetch(R.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.qty) }) })
      .then(r => r.json()).then(renderCart);
  });

  /* product page */
  const form = $('[data-product-form]');
  if (form) {
    const pj = JSON.parse($('#product-json').textContent);
    const colorAssets = $('#color-assets') ? JSON.parse($('#color-assets').textContent) : {};
    const idInput = form.querySelector('[name="id"]'), qtyInput = form.querySelector('[name="quantity"]');
    const btn = form.querySelector('[type="submit"]'), priceEl = $('[data-price]'), main = $('#gmain');
    const isQuote = form.dataset.quote === 'true';
    let cur = pj.variants.find(v => String(v.id) === idInput.value) || pj.variants[0];
    const sel = [...cur.options];
    const setMain = (src, photo) => { if (!src) return; main.innerHTML = `<img class="${photo ? 'photo' : ''}" src="${src}" alt="${esc(pj.title)}">`; };
    $$('[data-opt-index]').forEach(group => {
      const i = +group.dataset.optIndex;
      group.addEventListener('click', e => {
        const b = e.target.closest('button[data-value]'); if (!b) return;
        sel[i] = b.dataset.value;
        group.querySelectorAll('button').forEach(x => x.classList.toggle('on', x === b));
        group.querySelector('[data-opt-label]').textContent = b.dataset.value;
        const v = pj.variants.find(v => v.options.every((o, k) => o === sel[k]));
        if (!v) { btn.disabled = true; btn.textContent = '選択できません'; return; }
        cur = v; idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (isQuote) { btn.disabled = false; btn.textContent = 'お見積りリストに追加'; }
        else { btn.disabled = !v.available; btn.textContent = v.available ? 'カートに追加' : '売り切れ'; }
        if (v.featured_media && v.featured_media.preview_image) setMain(v.featured_media.preview_image.src + '&width=1200', false);
        else if (colorAssets[b.dataset.value]) setMain(colorAssets[b.dataset.value], false);
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      });
    });
    $$('[data-qty-step]').forEach(b => b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Math.min(99, (+qtyInput.value || 1) + +b.dataset.qtyStep)); $('#qn').textContent = qtyInput.value; }));
    form.addEventListener('submit', e => {
      e.preventDefault();
      if (isQuote) {
        const img = (main.querySelector('img') || {}).src || '';
        window.YOUONQuote.add({ id: String(cur.id), title: pj.title, variant: cur.title !== 'Default Title' ? cur.title : '', qty: +qtyInput.value || 1, image: img, url: location.pathname });
        toast(`${pj.title}${cur.title !== 'Default Title' ? '（' + cur.title + '）' : ''} をお見積りリストに追加しました`);
        window.YOUONQuote.open(); return;
      }
      btn.disabled = true;
      fetch(R.cart_add + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(r => r.json().then(j => ({ ok: r.ok, j })))
        .then(({ ok, j }) => { btn.disabled = false; if (!ok) { toast(j.description || 'カートに追加できませんでした'); return; }
          toast(`${pj.title}${cur.title !== 'Default Title' ? '（' + cur.title + '）' : ''} をカートに追加しました`); return refreshCart().then(openCart); })
        .catch(() => { btn.disabled = false; form.submit(); });
    });
    const thumbs = $('#gthumbs');
    if (thumbs) thumbs.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return;
      thumbs.querySelectorAll('button').forEach(x => x.classList.toggle('on', x === b)); setMain(b.dataset.src, b.dataset.photo === '1'); });
  }

  /* FAQ tabs */
  const tabs = $('[data-faq-tabs]');
  if (tabs) tabs.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return;
    tabs.querySelectorAll('button').forEach(x => x.classList.toggle('on', x === b));
    $$('.faq-group').forEach(g => g.hidden = b.dataset.k !== 'all' && g.dataset.k !== b.dataset.k); });

  /* News toggles */
  document.addEventListener('click', e => { const b = e.target.closest('.news .row'); if (b) b.parentNode.classList.toggle('open'); });

  /* Contact prefill: ?product=… / ?cart=1 / ?topic=u200 */
  const ta = $('#ContactForm-body');
  if (ta) {
    const q = new URLSearchParams(location.search), sel = $('#ContactForm-type');
    const fill = (lines, type) => { if (!lines.length) return; ta.value = `【お見積り・お問い合わせ製品】\n${lines.join('\n')}\n\n【ご質問・ご要望】\n`; if (sel && type) sel.value = type; };
    if (q.get('quote')) fill(window.YOUONQuote.items().map(i => `・${i.title}${i.variant ? '（' + i.variant + '）' : ''} × ${i.qty}`), 'お見積り・ご購入');
    else if (q.get('topic') === 'bulk' && q.get('product')) fill([`・${q.get('product')}（大口・法人でのご購入のご相談）`], '法人・自治体での導入');
    else if (q.get('product')) fill([`・${q.get('product')}`], 'お見積り・ご購入');
    else if (q.get('topic') === 'u200') fill(['・U200 水素アシスト自転車（導入・試乗のご相談）'], '法人・自治体での導入');
    else if (q.get('topic') === 'package') fill(['・セット・パッケージの導入について'], 'お見積り・ご購入');
    else if (q.get('topic')) fill([`・${q.get('topic')}`], q.get('topic').includes('業務用') ? '法人・自治体での導入' : 'お見積り・ご購入');
    else if (q.get('cart')) fetch(R.cart + '.js').then(r => r.json()).then(c => fill(c.items.map(i => `・${i.product_title}${i.variant_title ? '（' + i.variant_title + '）' : ''} × ${i.quantity}`), '法人・自治体での導入'));
    // 送信完了後はお見積りリストを空にする
    if (document.querySelector('#ContactForm .ok')) window.YOUONQuote.clear();
  }
})();

/* Fixed header + back to top (youon.co.jp style progress ring) */
(() => {
  const hdr = document.querySelector('.hdr'); if (!hdr) return;
  const wrap = hdr.closest('.shopify-section') || hdr.parentNode;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ヘッダーの高さ分の場所を確保（固定時にページがずれないように）
  const reserve = () => { wrap.style.minHeight = hdr.offsetHeight + 'px'; };
  reserve();

  // 戻るボタン（H2 バルーン）
  const btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'balloon-top'; btn.setAttribute('aria-label', 'ページの先頭へ戻る');
  btn.innerHTML = '<svg viewBox="0 0 52 74" aria-hidden="true"><defs><linearGradient id="btg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#3fdccf"/><stop offset="1" stop-color="#0aa9a7"/></linearGradient><radialGradient id="bth" cx=".33" cy=".3" r=".65"><stop offset="0" stop-color="#fff" stop-opacity=".8"/><stop offset=".45" stop-color="#fff" stop-opacity="0"/></radialGradient></defs>'
    + '<g class="bt-b"><path d="M26 52 C 22 58, 30 63, 26 72" fill="none" stroke="#9fb5b3" stroke-width="1.6" stroke-linecap="round"/>'
    + '<circle cx="26" cy="25" r="24" fill="url(#btg)"/><circle cx="26" cy="25" r="24" fill="url(#bth)"/><path d="M23 49 h6 l-2 -2.5 h-2z" fill="#0aa9a7"/>'
    + '<text x="26" y="32.5" text-anchor="middle" font-size="20" font-weight="900" fill="#fff" font-family="Noto Sans JP, sans-serif">H<tspan font-size="11" dy="3">2</tspan></text></g></svg>'
    + '<span class="vh">ページの先頭へ</span>';
  document.body.appendChild(btn);

  const scrollTop = () => {
    const jump = top => window.scrollTo({ top, left: 0, behavior: 'instant' });
    if (reduce) { jump(0); return; }
    const root = document.documentElement, prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    const start = window.scrollY, t0 = performance.now(), dur = 650;
    const step = now => { const p = Math.min(1, (now - t0) / dur); const e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      jump(Math.round(start * (1 - e))); if (p < 1) requestAnimationFrame(step); else { root.style.scrollBehavior = prev; btn.classList.remove('fly'); } };
    requestAnimationFrame(step);
  };
  btn.addEventListener('click', () => { if (!reduce) btn.classList.add('fly'); scrollTop(); btn.blur(); });

  let ticking = false;
  const update = () => {
    const y = window.scrollY || document.documentElement.scrollTop;
    const startFix = wrap.getBoundingClientRect().top + y;          // お知らせバーの下端
    const fixed = y > startFix;
    if (fixed !== hdr.classList.contains('is-fixed')) hdr.classList.toggle('is-fixed', fixed);
    btn.classList.toggle('show', y > window.innerHeight && !btn.classList.contains('fly'));
    ticking = false;
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', () => { reserve(); update(); });
  window.addEventListener('load', () => { reserve(); update(); });
  update();
})();

/* カテゴリ絞り込み（/collections/all?cat=bike など） */
(() => {
  const grid = document.querySelector('[data-cat-grid]'); if (!grid) return;
  const key = new URLSearchParams(location.search).get('cat'); if (!key) return;
  let meta = {}; try { meta = JSON.parse(document.getElementById('cat-meta').textContent); } catch (e) {}
  const cards = [...grid.querySelectorAll('.card')];
  let shown = 0;
  cards.forEach(c => { const ok = c.dataset.cat === key; c.hidden = !ok; if (ok) shown++; });
  const empty = document.querySelector('[data-cat-empty]'); if (empty) empty.hidden = shown > 0;
  const m = meta[key];
  if (m) {
    document.querySelectorAll('[data-cat-title],[data-cat-crumb]').forEach(e => e.textContent = m.ja);
    const lead = document.querySelector('[data-cat-lead]'); if (lead) lead.textContent = m.lead;
    document.title = m.ja + ' | ' + document.title.split('|').pop().trim();
  }
  document.querySelectorAll('[data-cat-tabs] a').forEach(a => a.classList.toggle('on', a.dataset.k === key));
})();
